import type { InventoryItemRow } from "~/@types/inventoryItemRow";

const hasAnyInventory = (
	item: Partial<Pick<InventoryItemRow, "allocatedQuantity" | "availableQuantity" | "quantity">>
): boolean => (item.quantity ?? 0) !== 0 || (item.availableQuantity ?? 0) !== 0 || (item.allocatedQuantity ?? 0) !== 0;

export default hasAnyInventory;
